import axios from '../../../plugins/axios.js';

export default {
    async loadPayments({ commit, state, rootState }, payload) {
        const response = await axios.get('payments', {
            params: {
                ...payload,
                account_id: rootState.authUser.account.id,
            },
        });

        const data = response.data.data;
        const meta = response.data.meta;

        if (state.pagination.currentPage == meta.current_page) {
            commit('setPayments', data);

            commit('updatePagination', {
                from: meta.from,
                to: meta.to,
                total: meta.total,
                lastPage: meta.last_page,
            });
        }
    },

    async createPayment({ commit }, payload) {
        const response = await axios.post('payments', payload);
        const payment = response.data.data;

        commit('addPayment', payment);

        return payment;
    },

    async updatePayment({ commit }, { id, payload }) {
        const response = await axios.put(`payments/${id}`, payload);
        const payment = response.data.data;

        commit('updatePayment', payment);

        return payment;
    },

    async deletePayment({ commit }, id) {
        await axios.delete(`payments/${id}`);

        commit('removePayment', id);
    },

    async sendPaymentLink({ commit }, { id, payload }) {
        const response = await axios.post(`payments/${id}/send-link`, payload);

        const payment = response.data.data;

        commit('updatePayment', payment);

        return payment;
    },
};
